import React from 'react';
import ItemContainer from '../ItemContainer';
import donutIcon from 'assets/images/donut.svg';
import SVG from 'react-inlinesvg';
import {
  Cell,
  Label,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
} from 'recharts';
import { useSegmentSelection } from '../../../../../../../../hooks/charts/pieChart/useSegmentSelection';
import { useFormattedData } from './hooks/useFormattedData';
import { useGetDataColor } from './hooks/useGetDataColor';
import PieChartActiveShape from '../../../../../../../../components/Charts/PieChart/PieChartActiveShape';
import { usePieChartSum } from '../../../../../../../../hooks/charts/pieChart/usePieChartSum';
import { useTranslations } from '../../../../../../../../hooks/useTranslations';
import { useCookie } from '../../../../../../../../hooks/useCookie';
import { ViewTheme } from '../../../../../../../../interfaces/ui';

const Squeezes = () => {
  const { selectedSegmentIndex, handleSelectSegment, handleResetSegment } =
    useSegmentSelection();

  const formattedData = useFormattedData();
  const getColor = useGetDataColor();
  const totalSum = usePieChartSum(formattedData);

  const theme = useCookie<ViewTheme>('theme');

  const { attachPrefix, wrapWithIntl } = useTranslations(
    'Cases.CaseDetails.AwareCase.Squeezes'
  );

  return (
    <ItemContainer
      title={wrapWithIntl(attachPrefix('squeezes'))}
      icon={<SVG src={donutIcon} />}
    >
      <ResponsiveContainer width="100%" height="100%">
        <PieChart style={{ strokeWidth: 8 }}>
          <Pie
            activeIndex={selectedSegmentIndex}
            activeShape={PieChartActiveShape}
            cy="50%"
            cx="50%"
            data={formattedData}
            labelLine={false}
            innerRadius="50%"
            outerRadius="85%"
            stroke={theme === ViewTheme.Dark ? '#212529' : '#fff'}
            dataKey="value"
            strokeWidth={5}
            cornerRadius={3}
            onMouseEnter={handleSelectSegment}
            onMouseLeave={handleResetSegment}
          >
            {formattedData.map((entry) => (
              <Cell key={`cell-${entry.name}`} fill={getColor(entry)} />
            ))}
            {selectedSegmentIndex === undefined && (
              <Label
                value={totalSum.toFixed(0)}
                offset={0}
                position="center"
                fontSize={20}
                fill={theme === ViewTheme.Dark ? '#fff' : '#313131'}
              />
            )}
          </Pie>
          <Legend
            layout="horizontal"
            align="center"
            verticalAlign="bottom"
            iconType="circle"
          />
        </PieChart>
      </ResponsiveContainer>
    </ItemContainer>
  );
};

export default Squeezes;
